import * as types from './actionTypes';

export const getPackageList = (payload) => ({
  type: types.GET_PACKAGE_LIST,
  payload,
});

export const getNextPagePackageList = (payload) => ({
  type: types.GET_NEXT_PAGE_PACKAGE_LIST,
  payload,
});

export const setPackageList = (payload) => ({
  type: types.SET_PACKAGE_LIST,
  payload,
});

export const getPackageDetails = (payload) => ({
  type: types.GET_PACKAGE_DETAILS,
  payload,
});

export const setPackageDetails = (payload) => ({
  type: types.SET_PACKAGE_DETAILS,
  payload,
});

export const clearPackageView = () => ({
  type: types.CLEAR_PACKAGE_VIEW,
});

export const updatePackage = (payload) => ({
  type: types.UPDATE_PACKAGE,
  payload,
});

export const updatePackageSuccess = (payload) => ({
  type: types.UPDATE_PACKAGE_SUCCESS,
  payload,
});

export const createPackage = (payload) => ({
  type: types.CREATE_PACKAGE,
  payload,
});

export const createPackageSuccess = (payload) => ({
  type: types.CREATE_PACKAGE_SUCCESS,
  payload,
});

export const createPackageFailure = (payload) => ({
  type: types.CREATE_PACKAGE_FAILURE,
  payload,
});

export const updatePackageStatus = (payload) => ({
  type: types.UPDATE_PACKAGE_STATUS,
  payload,
});

export const updatePackageStatusSuccess = (payload) => ({
  type: types.UPDATE_PACKAGE_STATUS_SUCCESS,
  payload,
});

export const updatePackageStatusFailure = (payload) => ({
  type: types.UPDATE_PACKAGE_STATUS_FAILURE,
  payload,
});

export const setStatusUpdateSuccess = (payload) => ({
  type: types.SET_STATUS_UPDATE_SUCCESS,
  payload,
});
